import * as angular from 'angular';

import { ComponentDefinition, TagDefinition, ImportResult, TagImportResultDto } from '../../models';
import { ITagDefinitionService, ILoggerService } from '../../services/';

class TagsImportController implements angular.IComponentController {
    fileList: FileList;
    importResult: ImportResult;
    isLoading: boolean;
    onRefresh: (data: { updated: TagDefinition[] }) => void;

    static $inject = [
        'tagDefinitionService',
        'loggerService'
    ];

    constructor(
        private _tagService: ITagDefinitionService,
        private _loggerService: ILoggerService
    ) {
    }

    $onInit() {
        /* empty */
    }

    upload(files: FileList) {
        this.isLoading = true;
        if (files && files.length) {
            this._tagService
                .upload(files[0])
                .then(data => this.onUpload(data))
                .catch(reason => this._loggerService.logError(reason.data.Message))
                .finally(() => this.isLoading = false);
        }
    }

    private onUpload(data: TagImportResultDto) {
        this.importResult = {
            result: data.result,
            createdCount: data.created.length,
            updatedCount: data.updated.length,
            failedCount: data.notUpdated.length
        };
        if (this.onRefresh) {
            this.onRefresh({ updated: data.created.concat(data.updated) });
        }
    }
}

export const wtTagsImport: ComponentDefinition = {
    componentId: 'wtTagsImport',
    controller: TagsImportController,
    template: require('./tagsImport.component.html'),
    controllerAs: 'vm',
    bindings: {
        onRefresh: '&?',
        isLoading: '=?'
    }
};
